export const RISK_LEVELS = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
  CRITICAL: "CRITICAL",
};

export const RISK_LEVELS_LABELS = {
  [RISK_LEVELS.LOW]: "Faible",
  [RISK_LEVELS.MEDIUM]: "Moyen",
  [RISK_LEVELS.HIGH]: "Élevé",
  [RISK_LEVELS.CRITICAL]: "Critique",
};
